import { generators } from './data/data.generators';

export const tool = {
  name: 'populate-scene',
  description:
    'Generates a 3D scene by placing items on a virtual 6x6 grid, guided by a natural language prompt. Useful for arranging furniture, props, or decorations in spatially-aware layouts. ' +
    'The scene is viewed isometrically and tilted 45 degrees. The center of the grid is at [0, 0, 0], with the furthest point at [0, 0, 0] and the closest at [5, 0, 5]. ' +
    'Items occupy space in the positive direction of the x and z axes.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      models: {
        type: 'array',
        description:
          'An array of model objects to place on a 6x6 grid. Each model has a generator ID and a position, optionally with a rotation.',
        items: {
          type: 'object',
          properties: {
            generatorId: {
              type: 'string',
              enum: generators,
              description: 'The generator ID used to instantiate this model (e.g., "G-203").',
            },
            position: {
              type: 'array',
              items: { type: 'number' },
              minItems: 3,
              maxItems: 3,
              description:
                'The 3D position of the model [x, y, z]. The x and z coordinates must correspond to a cell in the 6x6 grid (0–5).',
            },
            rotation: {
              type: 'number',
              enum: [0, 90, 180, 270],
              description:
                'Optional rotation of the model in degrees (must be 0, 90, 180, or 270).',
            },
          },
          required: ['generatorId', 'position'],
        },
      },
      message: {
        type: 'string',
        description:
          'A natural language prompt describing the desired scene. The prompt should specify the type of environment or mood (e.g., "generate a cozy living room with a couch and coffee table"). This guides which models are chosen and how they’re arranged.',
      },
    },
    required: ['models', 'message'],
  },
};
